'use client';

import { calculateCartItemTotal, formatTotemPrice } from '@/features/totems/domain/service/totem-price';
import { CartTotalsBreakdown } from '@/features/totems/presentation/components/web-totem/layout/cart-totals-breakdown';
import { useTotemCartState } from '@/features/totems/presentation/providers/web-totem/totem-provider';

export function TotemCheckoutSummary() {
  const { cart } = useTotemCartState();

  return (
    <div className="flex h-full min-h-0 flex-col">
      <h3 className="mb-4 shrink-0 text-xs font-bold tracking-wider text-muted-foreground uppercase">Resumen</h3>

      <div className="min-h-0 flex-1 overflow-y-auto pr-2">
        <ul className="flex flex-col gap-4 text-sm font-medium">
          {cart.items.map(item => {
            const rowTotal = calculateCartItemTotal(item);
            return (
              <li
                key={item.id}
                className="flex justify-between gap-4 border-b border-border/50 pb-4 last:border-0 last:pb-0"
              >
                <span className="flex-1 text-muted-foreground">
                  <span className="mr-1 text-foreground">{item.quantity}x</span>
                  {item.name}
                </span>
                <div className="flex min-w-[80px] flex-col items-end text-right">
                  {item.originalPrice && item.originalPrice > item.unitPrice && (
                    <span className="text-xs text-muted-foreground line-through">
                      {formatTotemPrice(item.originalPrice * item.quantity)}
                    </span>
                  )}
                  <span className="font-bold text-orange-500">{formatTotemPrice(rowTotal)}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-6">
        <div className="mb-4 h-1.5 w-full rounded-full bg-muted-foreground/30" />
        <CartTotalsBreakdown items={cart.items} discount={cart.discount} className="mb-3" />
        <div className="flex items-end justify-between">
          <span className="text-xl font-bold">Total</span>
          <span className="text-4xl font-extrabold text-orange-500">{formatTotemPrice(cart.total)}</span>
        </div>
      </div>
    </div>
  );
}
